// src/pages/ConnectionPage.js
import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { supabase } from '../supabaseClient';

const ConnectionPage = () => {
  const { uuid } = useParams();
  const [cardData, setCardData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCard = async () => {
      setLoading(true);
      const { data, error } = await supabase
        .from('cards')
        .select('*')
        .eq('uuid', uuid)
        .single();
      if (error) {
        console.error('Error fetching card:', error);
      } else {
        setCardData(data);
      }
      setLoading(false);
    };
    fetchCard();
  }, [uuid]);

  const copyLinkToClipboard = () => {
    navigator.clipboard.writeText(window.location.href);
    alert('Link copied to clipboard!');
  };

  if (loading) return <div>Loading...</div>;

  if (!cardData) {
    return (
      <div>
        <h2>This card is not registered.</h2>
        <Link to="/signup">Sign Up</Link>
      </div>
    );
  }

  const {
    profile_pic,
    social_links,
    about,
    call,
    email,
    text,
    pictures,
    custom_slug,
  } = cardData;

  return (
    <div className="connection-page">
      <h2>{custom_slug || uuid}'s Connection Page</h2>
      
      {/* Profile Section */}
      <div className="profile-section">
        {profile_pic ? (
          <img 
            src={profile_pic} 
            alt="Profile" 
            style={{ maxWidth: '150px', borderRadius: '50%' }} 
          />
        ) : (
          <div>No Profile Picture</div>
        )}
        <button onClick={copyLinkToClipboard}>Share Link</button>
      </div>

      {/* Social Links Section */}
      <div className="social-links">
        <h3>Social Links</h3>
        <ul>
          {social_links?.facebook && (
            <li>
              <a href={social_links.facebook} target="_blank" rel="noopener noreferrer">
                <i className="fab fa-facebook"></i> Facebook
              </a>
            </li>
          )}
          {social_links?.twitter && (
            <li>
              <a href={social_links.twitter} target="_blank" rel="noopener noreferrer">
                <i className="fab fa-twitter"></i> Twitter
              </a>
            </li>
          )}
          {social_links?.instagram && (
            <li>
              <a href={social_links.instagram} target="_blank" rel="noopener noreferrer">
                <i className="fab fa-instagram"></i> Instagram
              </a>
            </li>
          )}
          {social_links?.website && (
            <li>
              <a href={social_links.website} target="_blank" rel="noopener noreferrer">
                <i className={social_links.websiteIcon ? `fa fa-${social_links.websiteIcon}` : 'fa fa-globe'}></i> Website
              </a>
            </li>
          )}
        </ul>
      </div>

      {/* About Section */}
      <div className="about-section">
        <h3>About</h3>
        <p>{about}</p>
      </div>

      {/* Contact Section */}
      <div className="contact-section">
        <h3>Contact</h3>
        {call && <p>Call: {call}</p>}
        {email && <p>Email: {email}</p>}
        {text && <p>Text: {text}</p>}
      </div>

      {/* Pictures / Gallery Section */}
      <div className="pictures-section">
        <h3>Gallery</h3>
        {pictures && pictures.length > 0 ? (
          pictures.map((pic, index) => (
            <div key={index} className="picture-item">
              <img src={pic.image_url} alt={pic.heading} style={{ maxWidth: '200px' }} />
              <h4>{pic.heading}</h4>
              <p>{pic.description}</p>
            </div>
          ))
        ) : (
          <p>No pictures available</p>
        )}
      </div>

      <div>
        <Link to="/edit-connection">Edit Connection</Link>
      </div>
    </div>
  );
};

export default ConnectionPage;
